import { type FC } from 'react';
import type { VirtualItem } from '@tanstack/react-virtual';
import type { DataTableDimensions, DataTableErrors } from '@/components/UI/DataTableV2/DataTable.model';
import { useDataTable } from '../DataTableProvider';
import { DataTableRowHeader } from './DataTableRowHeader';

interface StickyRowHeadersProps {
  virtualRows: Array<VirtualItem>;
  rowHeaderWidth: number;
  dimensions: DataTableDimensions;
  errors: DataTableErrors;
}

export const StickyRowHeaders: FC<StickyRowHeadersProps> = ({ virtualRows, rowHeaderWidth, dimensions, errors }) => {
  const { dataTableService } = useDataTable();
  return (
    <>
      {virtualRows.map((virtualRow) => (
        <DataTableRowHeader
          key={`row_header_${dataTableService.rowByIndex(virtualRow.index)?.id}`}
          rowIndex={virtualRow.index}
          rowHeaderWidth={rowHeaderWidth}
          positionOffset={{ x: 0, y: virtualRow.start }}
          errors={errors}
        />
      ))}
    </>
  );
};
